export default __webpack_public_path__ + "static/media/YOOZ-payment-solutions-image.fa104280.png";